import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const aboutParagraphs = [
  "WOW5050, in partnership with GlobalSOSNOW!, and inspired through its parent organization, Little River Historical Culture & Economic Development Corp., was created with a true heart to help people, strengthen families, and uplift communities wherever support is needed most.",
  "This platform is built on compassion, opportunity, unity, and action. It was designed not only to open doors, but also to bring people together, help communities grow from within, and create more connection, purpose, and hope in everyday life. WOW5050 encourages people to grow in their own communities, to socialize, to support one another, and to build stronger local and global networks through meaningful opportunities and shared purpose.",
];

const aboutList = [
  "Financial literacy, savings guidance, and mentoring",
  "Fundraising support for humanitarian and community causes",
  "Media publishing and legal listing resources",
  "Business growth and opportunity engagement",
  "Global franchising possibilities",
  "Marketplace selling opportunities",
  "Marketing and promotional exposure",
  "Volunteer and internship pathways",
  "Local and national government search listings",
  "Easy access to timely services, important resources, and other essential support",
];

const aboutEnding = [
  "Most importantly, WOW5050 is here to care for and assist people in need. We believe no one should feel forgotten during difficult times. That is why the platform also supports people through meaningful outreach and practical help, including emergency housing support, food assistance, on-the-job training, possible job placement opportunities, seasonal immigrant work opportunities, and volunteer pathways for both school requirements and court-ordered service.",
  "WOW5050 is more than a platform. It is a caring movement built with love, vision, and purpose. It exists to help people stand back up, move forward, connect with others, and discover real opportunities for personal growth, stability, and success. Whether someone is looking for support, a fresh start, meaningful work, a chance to give back, or a way to help others, WOW5050 is designed to be a place of hope and action.",
  "This is not just another idea — it is a living opportunity for humanity, community, empowerment, and change.",
  "WOW5050 is here now — a universe of help, hope, opportunity, and compassion for all. WOW5050 is a world with in its world universe.",
];

export default function AboutUs() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <main
      className="min-h-screen bg-[#020617] text-slate-100"
      style={{
        backgroundImage: "url('/network-bg.png')",
        backgroundSize: "cover",
        backgroundPosition: "center top",
      }}
    >
      <div className="min-h-screen bg-slate-950/70">
        <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
          <div className="rounded-[28px] border border-cyan-400/70 bg-[#020b1a]/90 p-5 shadow-[0_0_40px_rgba(34,211,238,0.12)] sm:p-7">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
              <button
                type="button"
                onClick={() => navigate("/")}
                className="inline-flex items-center gap-3 text-left"
              >
                <img
                  src="/wow-logo.jpeg"
                  alt="WOW50/50"
                  className="h-16 w-16 rounded-full object-cover ring-2 ring-cyan-400/70 sm:h-20 sm:w-20"
                />
                <div>
                  <div className="text-2xl font-semibold tracking-wide text-sky-300">WOW50/50</div>
                  <div className="text-sm text-sky-200">Wealth · Opportunity · Wellness · Fundraising</div>
                  <div className="text-xs text-slate-300">Global Media Publication</div>
                </div>
              </button>

              <div className="flex flex-wrap gap-2">
                <button
                  type="button"
                  onClick={() => navigate("/")}
                  className="rounded-full border border-sky-400/70 bg-sky-500/10 px-4 py-2 text-sm text-sky-100 hover:border-sky-300"
                >
                  Home
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/registration")}
                  className="rounded-full border border-emerald-400/70 bg-emerald-500/10 px-4 py-2 text-sm text-emerald-200 hover:border-emerald-300"
                >
                  Registration
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/marketplace")}
                  className="rounded-full border border-fuchsia-400/70 bg-fuchsia-500/10 px-4 py-2 text-sm text-fuchsia-100 hover:border-fuchsia-300"
                >
                  Marketplace
                </button>
              </div>
            </div>
          </div>

          <section className="mt-6 rounded-[32px] border border-cyan-400/80 bg-[#020b1a]/92 p-6 shadow-[0_0_50px_rgba(34,211,238,0.12)] sm:p-8 lg:p-10">
            <div className="max-w-4xl">
              <div className="inline-flex items-center rounded-full border border-cyan-400/40 bg-slate-950/50 px-4 py-1 text-xs text-cyan-200">
                About WOW50/50
              </div>
              <h1 className="mt-4 text-3xl font-semibold text-cyan-300 sm:text-4xl">About Us</h1>
              <p className="mt-3 text-base leading-8 text-slate-200 sm:text-lg">
                WOW5050, in partnership with GlobalSOSNOW!, and inspired through its parent organization, Little River Historical Culture & Economic Development Corp., was created with a true heart to help people, strengthen families, and uplift communities wherever support is needed most.
              </p>
            </div>

            <div className="mt-8 space-y-6 text-base leading-8 text-slate-100 sm:text-lg">
              {aboutParagraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}

              <div>
                <p className="mb-4 font-medium text-cyan-200">
                  Through WOW5050, individuals, families, and communities can access:
                </p>
                <ul className="grid gap-3 sm:grid-cols-2">
                  {aboutList.map((item) => (
                    <li
                      key={item}
                      className="rounded-2xl border border-slate-700/70 bg-slate-950/50 px-4 py-3 text-slate-100"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              {aboutEnding.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}
